import blog1 from './img/img-1.jpg';
import blog2 from './img/img-2.jpg';
import blog3 from './img/img-3.jpg';
import blog4 from './img/img-4.jpg';
import blog5 from './img/img-5.jpg';
import blog6 from './img/img-6.jpg';
import blog7 from './img/img-7.jpg';
import blog8 from './img/img-8.jpg';
import blog9 from './img/img-9.jpg';
import blog10 from './img/img-10.jpg';
import blog11 from './img/img-11.jpg';
import blog12 from './img/img-12.jpg';
import blog13 from './img/img-13.jpg';
import blog14 from './img/img-14.jpg';
import blog15 from './img/img-15.jpg';
import blog16 from './img/img-16.jpg';
import blog17 from './img/img-17.png';
import blog18 from './img/img-18.png';
import blog19 from './img/img-19.png';
import blog20 from './img/img-20.png';
import blog21 from './img/img-21.png';
import blog22 from './img/img-22.png';
import blog23 from './img/img-23.png';
import blog24 from './img/img-24.jpg';
import blog25 from './img/img-25.jpg';
import blog26 from './img/img-26.jpg';
import blog27 from './img/img-27.jpg';
import blog28 from './img/img-28.png';
import blog29 from './img/img-29.png';
import blog30 from './img/img-30.png';
import blog31 from './img/img-31.png';
import blog32 from './img/img-32.png';

export default [
    {
        id:32,
        image: blog32,
        title: 'Vitality Workout and Gym Clothing Brand ',
        category: 'UI UX design',
        description: 'Workout and Gym Clothing Brand - Vitality Mobile application UI design',
        tool:<a href="https://www.behance.net/gallery/142695259/Workout-and-Gym-Clothing-Brand-Vitality-Mobile-UI" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:30,
        image: blog30,
        title: 'Movie Tickets Booking Application',
        category: 'UI UX design',
        description: 'Movie Tickets Booking Application UI design for Infinity Cinemas',
        tool:<a href="https://www.behance.net/gallery/142118823/Infinity-Cinemas-Movie-Tickets-Booking-App-UI-Design" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:23,
        image: blog23,
        title: 'Supermarket Self checkout Mobile Application',
        category: 'UI UX design',
        description: 'Supermarket Self checkout Mobile Application where a user can scan barcodes, pay for the products online and check out physically at the store without the need for waiting in a queue ',
        tool:<a href="https://www.behance.net/gallery/140515885/Supermarket-self-checkout-mobile-application-UIUX" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:18,
        image: blog18,
        title: 'TV Time',
        category: 'UI UX design',
        description: 'Mobile Application UI',
        tool: <a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance' title='watch full design :'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
    {
        id:19,
        image: blog19,
        title: 'Mobile Application',
        category: 'UI UX design',
        description: 'Mobile Application UI ',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:29,
        image: blog29,
        title: 'Cool Comfort Ice Cream | Website UI design ',
        category: 'UI UX design',
        description: 'We are a big chain of stores that sells ice-cream. Our main product stands out because of its reputation and convenience. We want to convey a sense of comfort, while at the same time being calm.',
        tool:<a href="https://www.behance.net/gallery/141501797/Cool-Comfort-Ice-Cream-Website-UI-design" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
   
    {
        id:22,
        image: blog22,
        title: 'Vitality',
        category: 'UI UX design',
        description: 'Web Application UI | Vitality ',
        tool:<a href="https://www.behance.net/gallery/139619471/Vitality-Web-Application-UI-design" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:17,
        image: blog17,
        title: 'Food Hunt',
        category: 'UI UX design',
        description: 'Web Application Landing page design | UI',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
    /* {
        id:20,
        image: blog20,
        title: 'Star',
        category: 'UI UX design',
        description: 'Web Application Landing page UI | Star high performance race cars',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    }, */
    {
        id:21,
        image: blog21,
        title: 'West Coast',
        category: 'UI UX design',
        description: 'Web Application Landing page UI | West Coast ',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:14,
        image: blog14,
        title: 'Star',
        category: 'Logo design',
        description: 'We are a company that makes high-performance race cars with an emphasis on automation. Our target audience is toddlers. We want to convey a sense of wonder, while at the same time being business-like.',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
    {
        id:31,
        image: blog31,
        title: 'Cool Comfort',
        category: 'Logo design',
        description: 'Logo design for Ice Cream brand - Cool Comfort',
        tool:<a href="https://www.behance.net/gallery/141501797/Cool-Comfort-Ice-Cream-Website-UI-design" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
    {
        id:28,
        image: blog28,
        title: 'Vitality',
        category: 'Logo design',
        description: 'Logo design for Workout and Gym Clothing Brand - Vitality',
        tool:<a href="https://www.behance.net/gallery/139619471/Vitality-Web-Application-UI-design" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
        
    },
    {
        id:1,
        image: blog1,
        title: 'She/Her',
        category: 'illustartor',
        description: 'Adobe illustrator',
        tool:<a href="https://www.behance.net/gallery/137706901/She" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    
    {
        id:2,
        image: blog2,
        title: 'Moon',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/137708087/MOON" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:26,
        image: blog26,
        title: 'valkyries Series',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/141042699/Valkyries-series" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:25,
        image: blog25,
        title: 'Valkyries series',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/141042699/Valkyries-series" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:24,
        image: blog24,
        title: 'Valkyrie',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/141042699/Valkyries-series" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:27,
        image: blog27,
        title: 'Valkyries series',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/141042699/Valkyries-series" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:6,
        image: blog6,
        title: 'Banner Design',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:4,
        image: blog4,
        title: 'Blackout',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/gallery/138807481/Blackout" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    
    {
        id:7,
        image: blog7,
        title: 'Wo(man)',
        category: 'illustartor',
        description: 'Adobe illustarator',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:8,
        image: blog8,
        title: 'Pedigree',
        category: 'Brand design',
        description: 'logo design for a dog food brand called Pedigree.',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:12,
        image: blog12,
        title: 'COOL COMFORT ICE CREAM',
        category: 'Brand design',
        description: 'logo design for a ice cream shop called COOL COMFORT ICE CREAM..... A smooth, sweet, cold food prepared from a frozen mixture of milk products and flavorings, containing a minimum of 10 percent milk fat and eaten as a snack or dessert. The definition of ice cream is a soft, frozen treat made from milk fat',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:10,
        image: blog10,
        title: 'MOJO MADE',
        category: 'Brand design',
        description: ' MOJO MADE jewelleries ....Our products are unique in representing art, design and culture.  Our key mission is to introduce the finest, upscaled jewelry to customers worldwide, maintaining the essence of both traditional and innovative designs coupled with superb handcraft and quality with the latest technology. ',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:9,
        image: blog9,
        title: 'NIBBEL Chocolate',
        category: 'Brand design',
        description: 'logo design for a Chocolate brand called NIBBEL',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:11,
        image: blog11,
        title: 'Extra Gum Bubble Gum',
        category: 'Brand design',
        description: 'logo design for a bubble gum brand - Extra Gum Bubble Gum ',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    },
    {
        id:13,
        image: blog13,
        title: 'ARUGAM-BAY Beach wear',
        category: 'Brand design',
        description: 'Logo design for a beach wear brand called ARUGAM BAY',
        tool:<a href="https://www.behance.net/sachiththarinda1" class='social-icon-link behance'>
        <i class="fa fa-behance" aria-hidden="true"></i>
        </a>
    }
    

];